import Vue from 'vue'
import {
  Notify,
  Loading,
  Grid,
  GridItem,
  Dialog,
  Icon,
  List,
  DatetimePicker,
  Popup,
  Picker,
  Button,
  Field,
  CellGroup,
  RadioGroup,
  Radio,
  Uploader,
  Tag,
  ImagePreview,
  Cell,
  Empty,
  Tab,
  Tabs,
  Search,
  Steps,
  Step,
  PullRefresh,
  Checkbox,
  Stepper,
  Col,
  Row,
  Popover,
  Image,
  Toast,
  NoticeBar,
  Swipe,
  SwipeItem,
  DropdownMenu,
  DropdownItem
} from 'vant'

Vue.use(Notify)
Vue.use(Loading)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Dialog)
Vue.use(Icon)
Vue.use(List)
Vue.use(DatetimePicker)
Vue.use(Popup)
Vue.use(Button)
Vue.use(Field)
Vue.use(CellGroup)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Picker)
Vue.use(Uploader)
Vue.use(Tag)
Vue.use(Cell)
Vue.use(Empty)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Search)
Vue.use(Steps)
Vue.use(Step)
Vue.use(PullRefresh)
Vue.use(Checkbox)
Vue.use(Stepper)
Vue.use(Col)
Vue.use(Row)
Vue.use(Popover)
Vue.use(Image)
Vue.use(Toast)
Vue.use(NoticeBar)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)

Vue.prototype.$notify = Notify
Vue.prototype.$loading = Loading
Vue.prototype.$dialog = Dialog
Vue.prototype.$toast = Toast
Vue.prototype.$imagePreview = ImagePreview
